import microuniversoApi from "app/api/microuniversoApi"
import { useAppSelector } from "app/redux/hooks"
import { IOrcamento } from "app/types/IOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import globalMU from "globalMU"
import React, { useEffect, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros"
import { Parametro, ParametroPorItem } from "app/types/Parametro"
import { DespesaOrcamento, DespesasOrcamento } from "./DespesasOrcamento"



export const DespesasOrcamentoContainer = () => { // 440122
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
  const [dadosDespesas, setDadosDespesas] = useState<DespesaOrcamento[]>()
  const [parametros, setParametros] = useState<Parametro[]>([])
  const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]) // 433263


  const atualizarParametros = async () => {
      setParametros(
        await obterParametros({ nomes: []
        })
      )
  
      setParametrosPorFilial( // 433263
        await obterParametrosPorOidItem({
          nomes: ["UTILIZA_CONTROLE_DESPESAS_VENDA",
        ],
          oidItem: orcamento.OidFilialOrcamento
        })
      ) 
      
    }

  const obterListaDespesas = async () => {

    try {
      const resultado = await microuniversoApi.Orcamento.ObterListaPedidoDespesa(orcamento.IdentificadorOrcamento);
      setDadosDespesas(resultado)

    } catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      
      globalMU.unblockUI();
    }
  }


  
const atualizarDespesa  = async (oidDespesa: number, oidFornecedor: number, valor: number) =>
{
  if (oidDespesa > 0)
  {

    try {
        const resultado = await microuniversoApi.Orcamento.AtualizarPedidoDespesa(
        orcamento.IdentificadorOrcamento,
        oidDespesa,
        oidFornecedor,
        valor
      )
      setDadosDespesas(resultado)

      if (resultado != null && resultado.length == 0)
      {
        globalMU.showWarnMessage("Nenhum registro encontrado!")
      }
    } catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      globalMU.unblockUI();
    }



    const despesas = dadosDespesas?.map(d => {
      if (d.OidDespesa === oidDespesa)
      {
        return {
          ...d,
          OidFornecedor: oidFornecedor,
          Valor: valor
        }
      }
      return d
    })
    setDadosDespesas(despesas)
  }
}

useEffect(() => {
  atualizarParametros()
  obterListaDespesas()
  
}, [])


  return (
    <>
    {dadosDespesas != undefined && dadosDespesas != null && dadosDespesas.length > 0 && 
    <>
       <Breadcrumb2Container
          passos={["Despesas de Venda"]} 
          exibirBotaoLimpar={false}
          exibirBotaoVoltar={false}
          onBotaoLimparClicado={null}
          id="DespesasOrcamentoBreadcrumb"
      />

      <DespesasOrcamento
          somenteLeitura={orcamento.SomenteLeitura}
          despesas={dadosDespesas}
          onAtualizarDespesa={(id, oidFornecedor, valor) => {atualizarDespesa(id, oidFornecedor, valor)}}
        />
    </>
}
    </>
  )
}